<input
  type="text"
  autocomplete="new-password"
  [placeholder]="placeholder"
  (input)="onTextInput()"
  (change)="onInputChange()"
  (mousedown)="onInputMousedown()"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (keydown.arrowDown)="onUpDown($event, 1)"
  (keydown.arrowUp)="onUpDown($event, -1)"
  (keydown.pageDown)="onUpDown($event, 5)"
  (keydown.pageUp)="onUpDown($event, -5)"
  (keydown.end)="onUpDown($event, 10000)"
  (keydown.home)="onUpDown($event, -10000)"
  (keydown.enter)="onEnter($event)"
  [attr.disabled]="disabled || disabledState || undefined"
  [attr.readonly]="readonly || undefined"
  [attr.error]="error || undefined"
/>
<datalist (mousedown)="onListMousedown($event)" [attr.positionLeft]="positionDropdownLeft">
  <ng-content></ng-content>
</datalist>
